var markersArray = [];
var cities = [];
var stores = [];
var lang = "";

function slInit() {
  clearStores();
  // Parse JSON data

  $.ajax({
    type: "GET",
    url: jsonFile,
    dataType: "json",
    success: function (json) {
      const id = getUrlParam();

      $.each(json.data, function () {
        $.inArray(this.city, cities) > -1 ? null : cities.push(this.city);
        if (filterStore(this, id)) {
          stores.push(this);
        }
      });
      cities.sort();
    },
    data: {},
    async: false,
  });

  // Fill the drop-down menu
  //fillCityList();
  addStores(stores, null);
}

function filterStore(store, urlParam) {
  if (!urlParam) {
    return true;
  }
  return store.id === urlParam;
}

function getUrlParam() {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id"); // Replace 'param' with the name of your parameter

  return id;
}

function fillCityList() {
  $("#selector select[name=cities]").html(
    '<option value="select">' + text.selectCity + "</option>"
  );
  for (city in cities) {
    $("#selector select[name=cities]").append(
      '<option value="' + cities[city] + '">' + cities[city] + "</option>"
    );
  }
}

function findStores(prov, city) {
  if (stores[city] != null) {
    addStores(stores[city]);
  } else {
    var s = [];
    $.getJSON(jsonFile, function (json) {
      $.each(json.data, function () {
        if (this.city === city) s.push(this);
      });
      addStores(s);
    });
  }
  ga("send", "pageview", {
    page: text.pageURL + "/" + city,
  });
  return false;
}

function getClosest(latlng, postal) {
  var lat1 = latlng.lat();
  var lon1 = latlng.lng();
  var s = [];
  var sTooFar = [];
  $.getJSON(jsonFile, function (json) {
    $.each(json.data, function () {
      this["distance"] = getDistanceFromLatLonInKm(
        lat1,
        lon1,
        this.latitude,
        this.longitude
      );
      if (this.distance < 25) s.push(this);
      else sTooFar.push(this);
    });
    if (s.length != 0) {
      s.sort(sortByDistance);
      addStores(s);
    } else {
      sTooFar.sort(sortByDistance);
      tooFar(sTooFar);
    }
  });
  return false;
}

function showLocation(position) {
  var lat1 = position.coords.latitude;
  var lon1 = position.coords.longitude;
  var s = [];
  var sTooFar = [];
  $.getJSON(jsonFile, function (json) {
    $.each(json.data, function () {
      this["distance"] = getDistanceFromLatLonInKm(
        lat1,
        lon1,
        this.latitude,
        this.longitude
      );
      if (this.distance < 25) s.push(this);
      else sTooFar.push(this);
    });
    if (s.length != 0) {
      s.sort(sortByDistance);
      addStores(s);
    } else {
      sTooFar.sort(sortByDistance);
      tooFar(sTooFar);
    }
  });
  return false;
}

function errorHandler(error) {
  // DO NOTHING. On log l'erreur sans l'afficher, permet simplement de débugger.
  console.log("Geolocation error : code " + error.code + " - " + error.message);
}

function sortByDistance(a, b) {
  var aDist = a.distance;
  var bDist = b.distance;
  return aDist < bDist ? -1 : aDist > bDist ? 1 : 0;
}

function getPostalCodeCoordinate() {
  var geocoder = new google.maps.Geocoder();
  var postalCode = $("#selector input[name=postal]").val();

  geocoder.geocode({ address: postalCode }, function (results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      getClosest(results[0].geometry.location, postalCode);
    }
  });
  return false;
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function clearStores() {
  $("#store-info").html("");
}

function clearOverlays() {
  if (markersArray) {
    for (i in markersArray) {
      markersArray[i].setMap(null);
    }
  }
}

function randomString() {
  var sChrs = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
  var iLen = 25;
  var sRnd = "";
  for (var i = 0; i < iLen; i++) {
    var randomPoz = Math.floor(Math.random() * sChrs.length);
    sRnd += sChrs.substring(randomPoz, randomPoz + 1);
  }
  return sRnd;
}

function removeSpaces(value) {
  return value.split(" ").join("");
}

//May be moved to utils.js
function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.search);
  if (results == null) return "";
  else return decodeURIComponent(results[1].replace(/\+/g, " "));
}

function displayStoreSize() {
  $.getJSON(fileJson, function (json) {
    $(".storeSize").html(json.data.length);
  });
}

function addStores(json, postal) {
  clearStores();
  for (i in json) {
    addStore(json[i], postal);
  }
}

function tooFar(json, postal) {
  clearStores();
  $("#store-info").append(
    "<p>" + text.storeTooFar + '</p><hr class="separator" />'
  );
  addStore(json[0], postal);
}

function addStore(store, postal) {
  var token = randomString();
  var link =
    "http://maps.google.ca/maps?daddr=" +
    store.city +
    " - " +
    store["address1"];
  link = link.replace(/&/gi, "");
  link = link.replace(/,/gi, "");
  link = link.replace(/#/gi, "+");
  link = link.replace(/ /gi, "+");
  link = link + "@" + store.latitude + "," + store.longitude;
  if (postal != null) link = link + "&saddr=" + postal;

  var remarks = "";
  if (store.remarks) remarks = store.remarks;
  var hours = "";
  if (store.mon_opening) {
    hours =
      '<table class="table">' +
      '<tr><td class="day">' +
      text.mo +
      "</td>" +
      displayDayHours(store.mon_opening, store.mon_closing) +
      "</tr>" +
      '<tr><td class="day">' +
      text.tu +
      "</td>" +
      displayDayHours(store.tue_opening, store.tue_closing) +
      "</tr>" +
      '<tr><td class="day">' +
      text.we +
      "</td>" +
      displayDayHours(store.wed_opening, store.wed_closing) +
      "</tr>" +
      '<tr><td class="day">' +
      text.th +
      "</td>" +
      displayDayHours(store.thu_opening, store.thu_closing) +
      "</tr>" +
      '<tr><td class="day">' +
      text.fr +
      "</td>" +
      displayDayHours(store.fri_opening, store.fri_closing) +
      "</tr>" +
      '<tr><td class="day">' +
      text.sa +
      "</td>" +
      displayDayHours(store.sat_opening, store.sat_closing) +
      "</tr>" +
      '<tr><td class="day">' +
      text.su +
      "</td>" +
      displayDayHours(store.sun_opening, store.sun_closing) +
      "</tr>" +
      "</table>";
  } else {
    hours = '<p class="toBeConfirmed">' + text.toBeConfirmed + "</p>";
  }
  $("#store-info").append(
    '<div class="row row-separator">' +
      '<div class="store">' +
      '<div class="col-sm-3">' +
      '<a href="/pages/pro-hockey-life-' +
      store["name"].replace(/\s+/g, "-").toLowerCase() +
      '"><h3>' +
      store["name"] +
      "</h3></a>" +
      "<address>" +
      store["address1"] +
      "<br />" +
      (store["address2"] != null ? store["address2"] + "<br />" : "") +
      store.city +
      ", " +
      store.province +
      ", " +
      store.postal_code +
      "<br />" +
      '<a class="text-danger" href="tel:' +
      store.telephone +
      '">' +
      store.telephone +
      "</a><br />" +
      '<a class="btn btn-default" href="' +
      link +
      '" target="_blank" role="button" style="margin-top: 10px;">' +
      text.getDirections +
      "</a>" +
      "</address>" +
      hours +
      remarks +
      "</div>" +
      '<div class="col-sm-9">' +
      '<div class="map" id="' +
      token +
      '"></div>' +
      "</div>" +
      "</div>" +
      "</div><hr/>"
  );
  setMap(token, store.latitude, store.longitude);
}

function displayDayHours(opening, closing) {
  if (opening == "00:00" && closing == "00:00")
    return '<td colspan="3" align="center" style="color:#da2028">Closed</td>';
  else
    return (
      '<td align="right">' +
      hourFormat(opening) +
      "</td><td>&nbsp;-&nbsp;</td><td>" +
      hourFormat(closing) +
      "</td>"
    );
}

function hourFormat(hourString) {
  var h = hourString.split(":");
  if (h[0] < 12) return hourString + " AM";
  else if (h[0] == 12) return hourString + " PM";
  else return h[0] - 12 + ":" + h[1] + " PM";
}

function setMap(id, lat, lon) {
  var point = new google.maps.LatLng(lat, lon);

  var myMapOptions = {
    zoom: 15,
    center: point,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
  };
  var map = new google.maps.Map(document.getElementById(id), myMapOptions);
  /*
	var markers      = {
		  "he" : new google.maps.MarkerImage( '/img/stores/marker-images/image_he.png', new google.maps.Size(102,45), new google.maps.Point(0,0), new google.maps.Point(51,45) ),
		  "sr" : new google.maps.MarkerImage( '/img/stores/marker-images/image_sr.png', new google.maps.Size(102,45), new google.maps.Point(0,0), new google.maps.Point(51,45) ),
		  "eh" : new google.maps.MarkerImage( '/img/stores/marker-images/image_eh.png', new google.maps.Size(102,45), new google.maps.Point(0,0), new google.maps.Point(51,45) )  
	};
        */
  var shape = {
    type: "poly",
    coord: [
      94, 0, 97, 1, 99, 2, 99, 3, 100, 4, 100, 5, 100, 6, 101, 7, 101, 8, 101,
      9, 101, 10, 101, 11, 101, 12, 101, 13, 101, 14, 101, 15, 101, 16, 101, 17,
      101, 18, 101, 19, 101, 20, 101, 21, 101, 22, 101, 23, 101, 24, 101, 25,
      101, 26, 101, 27, 101, 28, 101, 29, 101, 30, 101, 31, 101, 32, 100, 33,
      100, 34, 100, 35, 99, 36, 99, 37, 97, 38, 94, 39, 61, 40, 59, 41, 58, 42,
      56, 43, 54, 44, 48, 44, 45, 43, 44, 42, 42, 41, 40, 40, 7, 39, 4, 38, 2,
      37, 2, 36, 1, 35, 1, 34, 1, 33, 0, 32, 0, 31, 0, 30, 0, 29, 0, 28, 0, 27,
      0, 26, 0, 25, 0, 24, 0, 23, 0, 22, 0, 21, 0, 20, 0, 19, 0, 18, 0, 17, 0,
      16, 0, 15, 0, 14, 0, 13, 0, 12, 0, 11, 0, 10, 0, 9, 0, 8, 0, 7, 1, 6, 1,
      5, 1, 4, 2, 3, 2, 2, 4, 1, 7, 0,
    ],
  };
  var marker = new google.maps.Marker({
    draggable: false,
    raiseOnDrag: false,
    shape: shape,
    map: map,
    position: point,
  });
  markersArray.push(marker);
}

function fillSpace() {
  if ($("#store-info").html() == "") {
    $("#store-info").html(filler);
  }
}
